import { Vector3 } from "core/Maths/math.vector";
import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
/**
 * Block used to apply a Normalize product between 2 vectors
 */
export class RewardNormalizeBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("vector", RewardGraphConnectionPointTypes.Vector3);
        this.registerOutput("normal", RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardNormalizeBlock";
    }

    public get vector(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    public get normal(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.vector.isConnected) {
            this.normal._storedFunction = null;
            this.normal._storedValue = null;
            return;
        }

        this.normal._storedFunction = (state) => {
            const vec = this.vector.getConnectedValue(state) as Vector3;
            return vec.normalize();
        };

        return this;
    }
}

RegisterClass("MELS.RewardNormalizeBlock", RewardNormalizeBlock);
